<div class="container-fluid">
  <div class="row pt-4 pl-4" style="font-size: 22px !important;
  font-weight: 400;
  color: #424242;">
    <h5><i class="fa fa-circle" style="color:#800000"></i> &nbsp;OverTime Reports</h5>
  </div>
<div id="mainContent" class="container">
  <div class="modal-body">
    <div class="row">
      <div class="col-sm-6">
        <div class="row">
          <label class="col-sm-4 col-form-label"
            >Financial Year<span class="text-danger">*</span></label
          >
          <div class="col-sm-6">
            <select
              class="form-control form-control-xs mt-1"
              [(ngModel)]="selectedFinancialYear"
              (change)="onFinancialYearSelected()"
            >
              <option value="">Select Year</option>
              <option *ngFor="let finance of financialList" [ngValue]="finance">
                {{ finance.name }}
              </option>
            </select>
          </div>
        </div>
      </div>
      <div class="col-sm-6">
        <div class="row">
          <label class="col-sm-4 col-form-label"
            >From Diary Closing Date<span class="text-danger">*</span></label
          >
          <div class="col-sm-6">
            <select
              class="form-control form-control-xs mt-1"
              [(ngModel)]="selectedFromClosing"
            >
              <option value="">Select Date</option>
              <option
                *ngFor="let closing of closingDateList"
                [ngValue]="closing"
              >
                {{ closing.closingDate }}
              </option>
            </select>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-6">
        <div class="row">
          <label class="col-sm-4 col-form-label"
            >To Diary Closing Date<span class="text-danger">*</span></label
          >
          <div class="col-sm-6">
            <select
              class="form-control form-control-xs mt-1"
              [(ngModel)]="selectedToClosing"
            >
              <option value="">Select Date</option>
              <option
                *ngFor="let closing of closingDateList"
                [ngValue]="closing"
              >
                {{ closing.closingDate }}
              </option>
            </select>
          </div>
        </div>
      </div>
      <div class="col-sm-6">
        <div class="row">
          <label class="col-sm-4 col-form-label"
            >Reporting Partner<span class="text-danger">*</span></label
          >
          <div class="col-sm-6">
            <mat-form-field appearance="legacy" style="width: 100%">
              <mat-select
                multiple
                [(ngModel)]="selectedPartner"
                #designatePartner="ngModel"
              >
                <mat-option
                  (click)="selectAllPartner(designatePartner, partnerList)"
                  [value]="0"
                  >Select All
                </mat-option>
                <mat-option
                  (click)="onPartnerSelected()"
                  #item
                  *ngFor="let partner of partnerList"
                  [value]="partner"
                >
                  {{ partner.firstName }} {{ partner.middleName }}
                  {{ partner.lastName }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-6">
        <div class="row">
          <label class="col-sm-4 col-form-label"
            >Employee Status<span class="text-danger">*</span></label
          >
          <div class="col-sm-6">
            <select
              class="form-control form-control-xs mt-1"
              [(ngModel)]="selectedEmployeeStatus"
              (change)="onPartnerSelected()"
            >
              <option value="1">Active</option>
              <option value="0">Closed</option>
            </select>
          </div>
        </div>
      </div>

      <div class="col-sm-6">
        <div class="row">
          <label class="col-sm-4 col-form-label"
            >Employee Name<span class="text-danger">*</span></label
          >
          <div class="col-sm-6">
            <mat-form-field appearance="legacy" style="width: 100%">
              <mat-select
                multiple
                [(ngModel)]="selectedEmployee"
                #designateEmployee="ngModel"
              >
                <mat-option
                  (click)="selectAllEmployee(designateEmployee, employeeList)"
                  [value]="0"
                  >Select All
                </mat-option>
                <mat-option
                  #item
                  *ngFor="let employee of employeeList"
                  [value]="employee"
                >
                  {{ employee.firstName }} {{ employee.middleName }}
                  {{ employee.lastName }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
          <div class="col-sm-2">
            <button
              class="btn btn-sm btn-block btn-outline-theme"
              (click)="onViewReport()"
            >
              View Details
            </button>
          </div>
          <div class="col-sm-2" *ngIf="showButton">
            <button (click)="exportToExcelClick()" class="btn btn-sm btn-block btn-outline-theme">
              <i class="fa fa-file-excel-o mr-2"></i>Export to Excel
            </button>
          </div>
          <div class="col-sm-2" *ngIf="showButton">
            <button (click)="exportToPDFClick()" class="btn btn-sm btn-block btn-outline-theme">
              <i class="fa fa-file-pdf-o mr-2"></i>Export as PDF
            </button>
          </div>
    </div>
  </div>
  </div>

  <div  class="container" id="mainContent">
  <div class="pt-3" *ngIf="overTimeReportList != null">
  <div class="row justify-content-center text-center">
    <span class="bg-theme-title">P G BHAGWAT LLP, Chartered Accountants</span>
  </div>
  <div class="row justify-content-center text-center ">
    <span>Suite 102, "Orchard", Dr Pai Marg, Baner, Pune - 411045 </span>
  </div>

    <div class="row mt-2 justify-content-center text-center">
        <span class="bg-theme-title">OverTime Report</span>
      </div>

  <div>
    <div class="pt-2" *ngFor="let data of overTimeReportList">
      <div class="row">
        <div class="col-sm-6">
      <label class="col-form-label"><b>Employee Name: </b> {{ data.firstName }} {{ data.lastName }}</label>
    </div>
  </div>
      <table class="table table-bordered table-sm table-striped">
        <thead>
          <tr>
            <th>Month Of OverTime</th>
            <th>OverTime In Hours</th>
            <th>Amount Paid</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let detail of data.details">
            <td>
              {{ changeMonthNumberToName(detail.month) }} / {{ detail.year }}
            </td>
            <td>{{ detail.otHrs| number : '1.2-2' }}</td>
            <td>{{ detail.otAmmount| number : '1.2-2' }}</td>
          </tr>
          <tr style="background-color: #e1f4f7">
            <td>Total</td>
            <td>{{ getTotalInHours(data)| number : '1.2-2'  }}</td>
            <td>{{ getTotalOtAmmount(data)|number:'1.2-2' }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>
</div>
</div>
